<template>
  <div class="whiteboard-bg-setting">
    <h2>更换背景</h2>
    <div class="options-container">
      <div
        v-for="(option, index) in backgroundOptions"
        :key="option.previewImage + index"
        class="option-card"
      >
        <div
          :class="[
            {
              'is-selected': selectedBackground === option.previewImage,
            },
            'preview',
          ]"
          @click="selectBackground(option)"
        >
          <div
            v-if="option.type === 'default'"
            class="color-preview"
            :style="{ backgroundColor: option.previewImage }"
          ></div>
          <img v-else :src="option.previewImage" class="preview-image" />

          <img
            v-if="selectedBackground === option.previewImage"
            src="@saas/pages/assets/images/live/live-set/selected.png"
            alt="已选中"
            class="selected-icon"
          />
          <div
            v-else-if="!option.type"
            class="delete-icon"
            @click.stop="handleDelete(index)"
          >
            <img
              src="@saas/pages/assets/images/live/live-set/delete.png"
              alt="删除"
              class="delete-icon-image"
            />
          </div>
        </div>
      </div>
      <div class="option-card upload-card" @click="handleUploadClick">
        <img
          class="upload-img"
          src="@saas/pages/assets/images/live/live-set/upload-btn.png"
          alt=""
        />
        <div class="upload-text">
          上传图片({{ currentCustomBackgroundsCount }}/{{
            maxCustomBackgrounds
          }})
        </div>
        <div class="upload-hint">大小1M以内，比例16:9</div>
      </div>
    </div>
    <!--  -->
    <select-file
      ref="selectFile"
      :hidden-upload="true"
      @confirm="confirmSelectFile"
      :forbidSelect="forbidSelect"
      :sizeLimit="1"
      proportionLimit="16:9"
      :limit="1"
    />
  </div>
</template>

<script>
import { checkPermission } from "@saas/components/src/utils/permission";
import {
  setTeacherRoomConf,
  getTeacherRoomConf,
} from "@saas/server-api/src/live-sdk";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import SelectFile from "@saas/components/src/components/SelectFile";
import screenShare from "@saas/pages/src/live/mixins/screen-share.js";
export default {
  name: "WhiteboardBgSetting",
  mixins: [screenShare],
  data() {
    return {
      selectedBackground: "rgba(255,255,255,1)",
      backgroundOptions: [
        {
          type: "default",
          previewImage: "rgba(255,255,255,1)",
        },
        {
          type: "default",
          previewImage: "rgba(30,30,32,1)",
        },
      ],
      fileType: "image",
      forbidSelect: [],
      limit: 1,
      maxCustomBackgrounds: 10, // 最多可上传的自定义背景图数量
    };
  },
  components: { SelectFile },
  computed: {
    ...mapState("live", [
      "whiteBoardService",
      "userStatus",
      "teacherRoomConfig",
    ]),
    currentCustomBackgroundsCount() {
      return this.backgroundOptions.filter((item) => item.type !== "default")
        .length;
    },
    canUpload() {
      return this.currentCustomBackgroundsCount < this.maxCustomBackgrounds;
    },
  },
  created() {
    // 获取当前白板背景
    getTeacherRoomConf().then((res) => {
      if (res.code === 1) {
        this.setTeacherRoomConfig(res.data);
        const { board_bg_img } = res.data;
        if (board_bg_img) {
          this.backgroundOptions = this.backgroundOptions.concat(
            board_bg_img.split(",").map((item) => {
              return {
                previewImage: item,
              };
            })
          );
        }
      } else {
        this.$darkMessage.error(res.message);
      }
    });
  },
  methods: {
    ...mapMutations("live", ["setTeacherRoomConfig"]),
    confirmSelectFile(file) {
      const newImageUrl = file[0].url;
      // 检查图片URL是否已存在
      const isExist = this.backgroundOptions.some(
        (item) => item.previewImage === newImageUrl
      );
      if (isExist) {
        this.$darkMessage.error("该图片已存在，请勿重复添加");
        return;
      }
      const boardBgImg = this.backgroundOptions
        .filter((item) => {
          return item.type !== "default";
        })
        .map((item) => {
          return item.previewImage;
        })
        .concat(newImageUrl)
        .join(",");
      setTeacherRoomConf({
        ...this.teacherRoomConfig,
        board_bg_img: boardBgImg,
      }).then((res) => {
        if (res.code === 1) {
          this.setTeacherRoomConfig({
            board_bg_img: boardBgImg,
          });
          this.backgroundOptions.push({
            previewImage: newImageUrl,
          });
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    selectBackground({ type, previewImage }) {
      const params = {
        type: "image",
        value: previewImage,
      };
      if (type === "default") {
        params.type = "color";
      }
      const boardBg =
        previewImage === "rgba(255,255,255,1)" ? "" : previewImage;
      setTeacherRoomConf({
        ...this.teacherRoomConfig,
        board_bg: boardBg,
      }).then((res) => {
        if (res.code === 1) {
          this.setTeacherRoomConfig({
            board_bg: boardBg,
          });
          this.whiteBoardService.setDrawEnable(true);
          this.whiteBoardService.setBoardBackground(params);
          this.whiteBoardService.setDrawEnable(
            this.userStatus.is_whiteboard === 1
          );
          this.selectedBackground = previewImage;
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    async handleUploadClick() {
      if (!this.canUpload) {
        this.$darkMessage.error(
          `最多可上传${this.maxCustomBackgrounds}张背景图`
        );
        return;
      }
      let { code, data, message } = await this.$store.dispatch(
        "user/getUserPermissions"
      );
      if (code === 1) {
        const havePermission = checkPermission([
          "action:material:file:view",
          "action:material:file:manage",
        ]);
        if (!havePermission) {
          this.$darkMessage.error("您没有素材中心的权限");
          return;
        }
        this.$refs["selectFile"].showPopup(-1);
      } else {
        this.$darkMessage.error(message);
      }
    },
    handleDelete(index) {
      const boardBgImg = this.backgroundOptions
        .filter((item, i) => {
          return item.type !== "default" && i !== index;
        })
        .map((item) => {
          return item.previewImage;
        })
        .join(",");
      setTeacherRoomConf({
        ...this.teacherRoomConfig,
        board_bg_img: boardBgImg,
      }).then((res) => {
        if (res.code === 1) {
          this.setTeacherRoomConfig({
            board_bg_img: boardBgImg,
          });
          this.backgroundOptions.splice(index, 1);
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
  },
  watch: {
    whiteBoardService: {
      handler(val) {
        if (val) {
          console.log("whiteBoardService", this.$store);
          // if (window.isElectron) {
          //   //
          // } else {
          // 获取当前白板背景
          this.selectedBackground = this.whiteBoardService.getBoardBackground();
          // }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
$dark-text: #ecedee;
$border-color: #27272a;
$selected-border-color: #165dff;
$card-bg: #1f1f21; // Slightly lighter dark background for cards
$preview-bg: #e0e0e0; // Light background for preview areas

.whiteboard-bg-setting {
  h2 {
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    margin-bottom: 12px;
  }

  .options-container {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
  }

  .option-card {
    flex: 0 0 calc(50% - 9px);
    max-width: calc(50% - 9px);
    width: 100%;
    height: 112px;
    cursor: pointer;

    .preview {
      position: relative;
      height: 100%;
      border-radius: 12px;
      border: 2px solid transparent;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $card-bg;
      .preview-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .color-preview {
        width: 100%;
        height: 100%;
      }

      .selected-icon {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: none;
        object-fit: contain;
        z-index: 2;
      }
      .delete-icon {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 32px;
        height: 32px;

        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 2;
      }

      .delete-icon-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      &.is-selected {
        border-color: $selected-border-color;
      }
    }
  }
  .upload-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #27272a;
    border: 1px solid rgba(229, 231, 235, 0.04);
    border-radius: 12px;
    .upload-img {
      width: 40px;
      height: 40px;
      margin-bottom: 12px;
    }

    .upload-text {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 4px;
    }

    .upload-hint {
      font-weight: 400;
      font-size: 12px;
      color: #a1a1aa;
      line-height: 16px;
    }
  }
}
</style>
